import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Image, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import logo from '../../../assets/logo_stride.png';
import { ErrorMessageEnum } from "../../../enums/app.enum";
import { useAuthState } from "../../../states/auth.state";
import SInputComponent from '../../s-input/s-input.component';
import CloseIcon from '../close-icon/close-icon.component';
import { useToasts } from 'react-toast-notifications';

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @param {*} props.pathto path redirect after set password
 * @returns
 */
const SetPasswordModal = (props: any) => {
  const history = useHistory();
  const authState = useAuthState();
  const { clearErrors, control, handleSubmit, setError, formState: { errors } } = useForm();
  const { addToast } = useToasts();
  const [showVerifyForm, setShowVerifyForm] = useState(false);

  const onSubmit = (formData: any) => {
  }

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} className="my-4" style={{ width: 'inherit' }} />
              <div>
                <p>Set Password</p>
              </div>
              <Row>
                <Col className='px-md-5'>
                  {!showVerifyForm && (
                    <>
                      <Form className="my-4" onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3 my-1" controlId="formBasicPassword">
                          <SInputComponent name="password" type='password' placeholder="New Password" control={control} error={errors.password}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage }
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 my-1" controlId="formBasicConfirmPassword">
                          <SInputComponent name="confirm_password" type='password' placeholder="Confirm New Password" control={control} error={errors.confirm_password}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage }
                            }}
                          />
                        </Form.Group>
                        <div className="d-grid gap-2">
                          <Button type="submit" variant="danger" size="lg" className="btn-block">Submit</Button>
                        </div>
                      </Form>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default SetPasswordModal;
